import { APICONSTANTS } from './../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { BcLineModel } from '../../models/societe-linked/bc/bc-line.model';
import { SocieteLinkedService } from '../societe-linked/societe-linked.service';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class BcLineService extends SocieteLinkedService<BcLineModel> {

  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEBCLINE, hostnameService);
  }

  getAllFromBc(idBc: number): Observable<BcLineModel[]> {
    return this.getAllbyId('GetFromBc/', idBc);
  }
}
